import { forwardRef, type ReactNode, type Ref } from 'react';
import { Box, type BoxProps } from '../Box/Box.js';
import { resolveSpacing } from '../../theme/index.js';
import './Group.css';

export interface GroupProps extends BoxProps {
  gap?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl' | number | string;
  align?: 'stretch' | 'start' | 'center' | 'end' | 'flex-start' | 'flex-end' | 'baseline';
  justify?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
  wrap?: 'wrap' | 'nowrap' | 'wrap-reverse';
  grow?: boolean;
  preventGrowOverflow?: boolean;
}

/** Horizontal layout: flex row with configurable gap, align, justify, wrap. */
export const Group = forwardRef(function Group(
  { gap = 'md', align = 'center', justify = 'flex-start', wrap = 'wrap', grow, preventGrowOverflow, style, children, ...rest }: GroupProps,
  ref: Ref<HTMLElement>
): ReactNode {
  return (
    <Box
      ref={ref}
      {...rest}
      className={['rr-group', grow && 'rr-group--grow', rest.className].filter(Boolean).join(' ')}
      style={{
        ...style,
        gap: resolveSpacing(gap),
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap,
        ...(preventGrowOverflow ? { minWidth: 0 } : null)
      }}
    >
      {children}
    </Box>
  );
});
